import { Injectable } from '@angular/core';

import { PromoApiService } from '@frontend/vanilla/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface MLifeProfile {
    mLifeNo: number;
    tier: string;
    tierDesc: string;
    tierCredits: number;
}

@Injectable({
    providedIn: 'root',
})
export class UserMLifeService {
    mlifeProfile: BehaviorSubject<MLifeProfile | null> = new BehaviorSubject<MLifeProfile | null>(null);
    private lastMlifeFetchTime: number = 0;
    private readonly cacheTimeMs: number = 30 * 60 * 1000;

    constructor(private apiService: PromoApiService) {
        this.loadMlifeProfile();
    }

    loadMlifeProfile(): void {
        const now = Date.now();
        if (now - this.lastMlifeFetchTime > this.cacheTimeMs) {
            this.lastMlifeFetchTime = now;
            this.apiService.get('rewardshub/getMLifeProfile').subscribe((profile: MLifeProfile) => {
                this.mlifeProfile.next(profile);
            });
        }
    }

    getMlifeProfile(): Observable<MLifeProfile | null> {
        this.loadMlifeProfile();
        return this.mlifeProfile.asObservable();
    }
}
